import React, { useEffect } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useInstitutionsServices } from "@/features/institutions/hooks/use-institutions-services";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { OneTimePassModal } from "@/features/accounts/payment/scraping/components/one-time-pass-modal";
import { usePaymentLoginInfo } from "@/features/accounts/payment/scraping/hooks/use-login-info";
import { useOneTimePassContext } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { SimpleForm } from "@/shared/components/text-box/simple-form";


interface Props {
  onTapCloseModal: () => void;
}

// 口座追加開始確認モーダル
export const SyncAccountsStartModal = (props: Props) => {
  const {
    // passbookType,
    onTapCloseModal,
  } = props;
  const {
    authType,
  } = useInstitutionsContext();
    const {
    getInstitutionsServices,
  } = useInstitutionsServices();
  const {
    selectedAccount
  } = useAccountGroupsContext();

  const {
    openHomeModal,
    setOpenHomeModal
  } = useModalContext();

  const {
    onClickConfirm,
  } = usePaymentLoginInfo();
    const {
      resetOtpContext,
    } = useOneTimePassContext();

  // 選択ボタンに付与するID
  const institutionsReauthorization = "sync_accounts_start";

  useEffect(() => {
    const fetchData = async () => {
      const resService = await getInstitutionsServices(
        selectedAccount?.industryCode || "",
        selectedAccount?.companyCode || "",
        selectedAccount?.branchCode || "",
      );
      // resからcodeに合致するものを見つけて、serviceNameを取得する
      const companyName = resService?.find(company => company.companyCode === selectedAccount?.companyCode)?.companyName || "";
      const serviceName = resService?.find(service => service.serviceCode === selectedAccount?.serviceCode)?.serviceName || "";
      const branchName = resService?.find(branch => branch.branchCode === selectedAccount?.branchCode)?.branchName || "";
      const institutionName = companyName + (branchName !== "" ? " " + branchName : "");
      const serviceType = serviceName.startsWith("[法人]") ? " [法人]" : "";
      // 上記を全てlocalStorageに保存して、SelectAccountsModalで使用する
      localStorage.setItem("institutionName", institutionName);
      localStorage.setItem("serviceName", serviceName);
      localStorage.setItem("branchName", branchName);
      localStorage.setItem("serviceType", serviceType);
    };
    fetchData();
  }, []);

  //  遷移ボタン選択時
  const handleSelect = async () => {
    // タイプによって分ける
    if (selectedAccount?.passbookType === "01") {
      setOpenHomeModal("SyncAccounts");
    }
    else if (selectedAccount?.passbookType === "03" || selectedAccount?.passbookType === "10") {
      if (selectedAccount?.scrapeType === 2) { // サーバ版スクレイピング
        const res = await onClickConfirm("updAcc");
        if (res) {
          if (res.paymentAccountId !== "") {
            setOpenHomeModal("SyncAccounts");
          }
        }
      } else if (selectedAccount?.scrapeType === 3) { // API版
        setOpenHomeModal("SyncAccounts");
      }
    }
  }

  const institutionType = () => {
    if (authType === "bank") {
      return "bank";
    } else if (authType === "crecaApi" || authType === "crecaLookScrape" || authType === "crecaLookApi") {
      return "card";
    } else if (authType === "emoneyLookScrape" || authType === "emoneyLookApi") {
      return "ev";
    }
  }

    // localStorageに保存した名前を取り出す
  const institutionName = localStorage.getItem("institutionName") || "";
  const serviceName = localStorage.getItem("serviceName") || "";

  return (
    <>
    { openHomeModal === "SyncAccountsStart" && (
    <BasePageModal
      title="口座を追加"
      className={`md-add-bank ${institutionType()}`}
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="上記金融機関の口座を追加する"
          onClick={() => handleSelect()}
          id={institutionsReauthorization}
          loadingNegative={true}
        />
      }
    >
      <h2>
        同じ金融機関の口座を追加します
      </h2>
      <dl>
        <SimpleForm
          id="companyName"
          value={institutionName}
          isReadOnly={true}
          title="金融機関"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
        <SimpleForm
          id="serviceName"
          value={serviceName}
          isReadOnly={true}
          title="サービス"
          onChange={() => {}}
          labelEnable={true}
          descriptionType={true}
        />
      </dl>
      <div className="notice">
        <p>
          上記の金融機関の口座を追加します。<br />
          選択中の口座と別のアカウントでご利用中の口座を追加したい場合は、
          「金融機関を追加する」から新規で登録を行ってください。
        </p>
      </div>
    </BasePageModal>
    )}
    { openHomeModal === "SyncOtp" && (
      <OneTimePassModal
        processType={"updAcc"}
        onTapCloseModal={() => {
          resetOtpContext();
          onTapCloseModal();
        }}
        onTapCompleteModal={async () => {
          const res = await onClickConfirm("updAcc");
          if (res) {
            if (res.paymentAccountId !== "") {
              setOpenHomeModal("SyncAccounts");
            }
            // 新たにOTPが要求された場合はコンテキストをリセットしない
            // (リセットするとoneTimePassListが空になりレンダリングエラーになる)
            if (res.otpFlg !== "1") {
              resetOtpContext();
            }
          } else {
            resetOtpContext();
          }
        }}
      />
    )}
    </>
  );
};